module.exports = __webpack_public_path__ + "img/PoliceTransport.7aa6967a.png";